import { FC } from 'react';
import { CatButton } from '@blocks-react/components/Button';
import styles from '../NotificationDrawer.module.scss';

interface ExpiredStatusTypes {
  isTodayDate?: string;
  link: string;
  REVIEW_QUOTE: string;
  VIEW_QUOTE: string;
}

export const ExpiredStatus: FC<ExpiredStatusTypes> = ({
  isTodayDate,
  link,
  REVIEW_QUOTE,
  VIEW_QUOTE,
}) => {
  return (
    <div
      data-testid="content-notification"
      className={`d-flex justify-content-start align-items-center ${styles['order-expired']}`}
    >
      <CatButton href={link} data-testid="expiredCta">
        {isTodayDate ? REVIEW_QUOTE : VIEW_QUOTE}
      </CatButton>
    </div>
  );
};
